<template>
  <v-dialog
    v-model="isVisible"
    no-click-animation
    :width="'55%'"
  >
    <v-card>
      <v-card-title>
        <h3>查詢進件次數/黑名單</h3>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <v-text-field v-model="profile.memberId"
                          placeholder="請輸入身分證" label="身分證">
            </v-text-field>
          </v-flex>
        </v-layout>
        <br>
        <div v-if="items.length">
          <h3>查詢結果</h3>
          <br>
          <v-layout v-for="item of items" :key="item.displayId">
            <v-expansion-panel>
              <v-expansion-panel-content>
                <template v-slot:header>
                  <div>
                      <span class="mb-3" style="font-size: 16px">{{item.applyDate}}
              | {{ getCaseProduct(item) }} | {{ getCaseType(item) }} | {{item.displayId}}
              | {{ getCaseStatus(item)}}
              | 是否為黑名單： <span :style="{color: (item.badCustomer === true || item.badCustomer === 1) ? 'red': 'black'}">{{ (item.badCustomer === true || item.badCustomer === 1) ? '是':'否'}}</span> </span>
                  </div>
                </template>
                <v-card>
                  <v-card-text>
                    <div v-if="item.logInfo">
                      {{ getLogContent(item.logInfo) }}
                    </div>
                    <div v-else>無紀錄</div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <hr>
          </v-layout>
        </div>
        <br>
        <v-layout>
          <v-flex>
            <span style="color: red">{{ message }}</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn class="red" dark text @click="cancelEvent">關閉</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" :loading="loading" dark text @click="confirmEvent">查詢</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { getFinanceSimpleList } from '@/store/actions';
import common from '@/mixins/common';

export default {
  name: 'SearchInfoDialog',
  props:{
    visible: Boolean,
  },
  data() {
    return {
      radioGroup: '0',
      profile: {
        memberId: '',
      },
      isVisible: false,
      message: '',
      items: [],
      loading: false,
    }
  },
  mixins:[common],
  watch: {
    visible(value) {
      this.isVisible = value;
    },
    isVisible(value) {
      if (!value) {
        this.cancelEvent()
      }
    },
  },
  methods: {
    ...mapActions(['getFinanceSimpleList']),
    getCaseProduct(item) {
      if (item.category === 2 && (item.productId === '0' || !item.productId)) {
        return '商品貸原融';
      }
      if (item.category === 3 && (item.productId === '0' || !item.productId)) {
        return '嘉好自有件';
      }
      if (item.productId === '0') {
        return '機車原融';
      }
      if (item.productId === '1') {
        return '借新還舊';
      }
      if (item.productId === '2') {
        return '他行代償';
      }
      return '機車原融';
    },
    getCaseType(item) {
      // //0優加 1優質 2一般 3借新還舊 4他行代償 5萬物代
      if (item.category === 2 && item.caseType === 3){
        return "超優";
      }
      if (item.category === 0 || item.category === 1 ||
        item.category === 2 ||
        item.category === 3) {
        const list = [
          { key: 0, value: "優加" },
          { key: 1, value: "優質" },
          { key: 2, value: "一般" },
        ];
        return list.find(i => i.key === item.caseType).value;
      }
      return "一般";
    },
    getCaseStatus(item) {
      // 0 進件中 1婉拒 2待捕
      const list = this.getCaseStatusList;
      if (!item.caseStatus) {
        return list[0].value;
      }
      return list.find(i => i.key === item.caseStatus).value;
    },
    cancelEvent(){
      this.isVisible = false;
      this.$emit('cancelEvent');
    },
    async confirmEvent(){
      if (this.profile.memberId === ''){
        this.message = '請輸入身分證';
        return;
      }
      try {
        this.loading = true;
        // this.isVisible = false;
        // this.$emit('confirmEvent', this.profile);
        const res = await this.getFinanceSimpleList({ searchValue:  this.profile.memberId});
        const result = res.data;
        if (result && result.statusCode === 0){
          console.log(`getFinanceSimpleList = ${JSON.stringify(result.data)}`);
          if (result.data){
            this.items = [];
            for (let item of result.data){
              this.items.push(item);
            }
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    getLogContent(log){
      console.log(`getLogContent = ${JSON.stringify(log)}`);
      let content = '';
      for (let customer of log.customer){
        content+= customer.calloutResult ? customer.calloutResult.comment : '';
      }
      return content;
    }
  },

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SearchInfoDialog.vue